import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import MenuItem from '../../data/MenuItem';
import useFlyoutThemes from './themes';

type FlyoutType = {
  subMenuItem: MenuItem;
};

function DropdownMenu({ subMenuItem }: FlyoutType) {
  const {
    flyoutSubUlContainer,
    flyoutSubUlClasses,
    flyoutSubLiClasses,
    flyoutSubLinkClasses,
    flyoutSubLinkThemeClasses,
    flyoutSubUlThemeClasses,
    flyoutSubLiThemeClasses,
  } = useFlyoutThemes({});

  return (
    <div className={twMerge(flyoutSubUlContainer)}>
      <ul className={twMerge('', flyoutSubUlClasses, flyoutSubUlThemeClasses)}>
        {subMenuItem.children.map((subitem: MenuItem) => (
          <li key={subitem.id} className={twMerge(flyoutSubLiClasses, flyoutSubLiThemeClasses)}>
            <a href={subitem.path} className={twMerge(flyoutSubLinkClasses, flyoutSubLinkThemeClasses)}>
              {subitem.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DropdownMenu;
